import { render, staticRenderFns } from "./connections-panel.vue?vue&type=template&id=1026f85c&scoped=true"
import script from "./connections-panel.vue?vue&type=script&lang=ts"
export * from "./connections-panel.vue?vue&type=script&lang=ts"
import style0 from "./connections-panel.vue?vue&type=style&index=0&id=1026f85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1026f85c",
  null
  
)

export default component.exports